import Typography from '@mui/material/Typography';
import moment from 'moment';

const StoryblokChangedAt = ({ blok }) => {
  const { changedAt, label } = blok;
  const formatL = moment.localeData().longDateFormat('L');
  return (
    <Typography variant="body1">
      <strong>{label}</strong> {moment.utc(changedAt, 'DD.MM.YYYY').format(formatL)}
    </Typography>
  );
};

export default StoryblokChangedAt;
